export default [{
  path: '/person',
  children: [{
    path: 'index',
    name: '我的',
    meta: {
      title: '我的'
    },
    component: () => import('@/views/person/list.vue')
  }, {
    path: 'info',
    name: '个人信息',
    meta: {
      title: '个人信息'
    },
    component: () => import('@/views/person/info.vue')
  }, {
    path: 'edit',
    name: '编辑个人信息',
    meta: {
      title: '编辑个人信息'
    },
    component: () => import('@/views/person/edit.vue')
  }]
}]